<div class="row p-3 {{ stickyScrolling ? 'm-0' : '' }}">
    <div class="col">
        <bot-list [bots]="botList"></bot-list>
    </div>
    <div class="col">
        <bot-builder [botSelection]="determinant.bots" (onChange)="updateBots($event)"></bot-builder>
    </div>
</div>
